import PropTypes from "prop-types";
import { FORTIFY_CONTACT_ENTRIES } from "lib/fortifyContact";
import { cn } from "lib/utils";

export function ContactEmails({ className, linkClassName }) {
  return (
    <ul className={cn("space-y-2 text-sm", className)}>
      {FORTIFY_CONTACT_ENTRIES.map(({ label, email }) => (
        <li key={email}>
          <span className="text-muted-foreground">{label}: </span>
          <a
            href={`mailto:${email}`}
            className={cn(
              "font-medium text-accent hover:underline",
              linkClassName
            )}
          >
            {email}
          </a>
        </li>
      ))}
    </ul>
  );
}

ContactEmails.propTypes = {
  className: PropTypes.string,
  linkClassName: PropTypes.string,
};
